import { render, staticRenderFns } from "./MoveStageConfig.vue?vue&type=template&id=7d87b9d1&scoped=true"
import script from "./MoveStageConfig.vue?vue&type=script&lang=js"
export * from "./MoveStageConfig.vue?vue&type=script&lang=js"
import style0 from "./MoveStageConfig.vue?vue&type=style&index=0&id=7d87b9d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d87b9d1",
  null
  
)

export default component.exports